export { default as AutoFocusPlugin } from './AutoFocusPlugin';
